module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.ae7272d.woff2";